import { Box } from "@chakra-ui/react";

import { useSelector } from "react-redux";
import { getReportDescription } from "../../store/helpers";
import ArrivalRatesPerHourReport from "../../components/organization/reports/ArrivalRatesPerHour";
import _ from "lodash";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const ArrivalRatesPerHour = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const { data } = reportsData;

  const title = `${reportIndex}. Arrival Rates Per Hour`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  });

  return (
    <Box>
      <Box mb="20px">
        <h1>{title}</h1>
        <p>{getReportDescription(reportRange).ArrivalRatesPerHour}</p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
          </div>
        ) : null}
      </Box>
      {!_.isEmpty(data) ? (
        <>
          <ArrivalRatesPerHourReport
            reportIndex={reportIndex}
            data={data}
          />
        </>
      ) : (
        <Box mt={10}>
          <p>No data available in this search</p>
        </Box>
      )}
    </Box>
  );
};

export default ArrivalRatesPerHour;
